import React from "react";

export default ({ className }) => <svg className={className} x="0px" y="0px" width="455.276px" height="455.276px" viewBox="0 0 455.276 455.276">
	<path fill="currentColor" d="M374.244,0H81.034c-9.532,0-17.292,7.757-17.292,17.286v177.84c0,9.529,7.76,17.286,17.292,17.286h293.21
		c9.534,0,17.291-7.757,17.291-17.286V17.286C391.535,7.757,383.778,0,374.244,0z M374.726,195.132c0,0.262-0.211,0.476-0.481,0.476
		H81.034c-0.269,0-0.482-0.219-0.482-0.476V17.286c0-0.263,0.213-0.476,0.482-0.476h293.21c0.271,0,0.481,0.219,0.481,0.476V195.132
		z M374.244,242.858H81.034c-9.532,0-17.292,7.761-17.292,17.291v177.84c0,9.532,7.76,17.287,17.292,17.287h293.21
		c9.534,0,17.291-7.755,17.291-17.287v-177.84C391.535,250.619,383.778,242.858,374.244,242.858z M374.726,437.989
		c0,0.264-0.211,0.476-0.481,0.476H81.034c-0.269,0-0.482-0.212-0.482-0.476v-177.84c0-0.262,0.213-0.481,0.482-0.481h293.21
		c0.271,0,0.481,0.22,0.481,0.481V437.989z"/>
</svg>
